const TOKEN_KEY = "rem_webview_token";
const USER_KEY = "rem_webview_user";
const APPLICATION_DRAFT_KEY = "rem_webview_application_draft";
const POST_APPLICATION_DRAFT_KEY = "rem_webview_post_application_draft";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const isAuthenticated = () => !!getToken();

export const getUserIds = () => {
  const user = getUser() || {};
  return {
    user_id: user.userId ?? user.user_id ?? "",
    role_id: user.roleId ?? user.role_id ?? "",
  };
};

export const setSession = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// Mirrors the whole in-progress application form (lead id, step, and every
// field the user has typed/picked) so a browser refresh on /application can
// restore it exactly — including edits the backend hasn't saved yet (steps
// that have no save API wired up still shouldn't lose their values on refresh).
export const saveApplicationDraft = (draft) => {
  try {
    localStorage.setItem(APPLICATION_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // storage full/unavailable — draft persistence is best-effort only
  }
};

export const getApplicationDraft = () => {
  try {
    const raw = localStorage.getItem(APPLICATION_DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearApplicationDraft = () => localStorage.removeItem(APPLICATION_DRAFT_KEY);

// Same idea for the post-application flow (Send to Bank / NOA / Contract
// Signing) — it has no save API at all yet, so this localStorage draft is the
// ONLY thing standing between a refresh and losing that work. Deliberately
// excludes the mail compose draft (transient, low value to persist) and the
// document list (re-fetched from get_docs; local blob preview URLs wouldn't
// survive a reload anyway).
export const savePostApplicationDraft = (draft) => {
  try {
    localStorage.setItem(POST_APPLICATION_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // storage full/unavailable — draft persistence is best-effort only
  }
};

export const getPostApplicationDraft = () => {
  try {
    const raw = localStorage.getItem(POST_APPLICATION_DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const clearPostApplicationDraft = () => localStorage.removeItem(POST_APPLICATION_DRAFT_KEY);
